import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { combineLatestInit } from 'rxjs/internal/observable/combineLatest';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: any = {
    login: null,
    password: null
  };

  isLoggedIn = false;
  isLoginFailed = false;
  isForeman = false;
  useraccess:any;
  errorMessage = '';
  roles: string[] = [];

  accoundId: number = 0;
  username?: string;
  first_name?: string;
  last_name?: string;
  currentRoute: string = "";

  ipAddress = '';
  userAgent = '';

  constructor(
    private authService: AuthService, 
    private http: HttpClient, 
    private tokenStorage: TokenStorageService,    
    private router: Router,
    private route: ActivatedRoute
  ) 
  { }

  ngOnInit(): void {
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;

     

      this.tokenStorage.getUserInfo().subscribe({
        next: (data: any) => {
          this.username = data.login;
          this.accoundId = data.account_id;
          this.first_name = data.first_name;
          this.last_name = data.last_name;
          if (data.account_id == 20){
            this.isForeman = true;
          }

        },
        error: (err: any) => {
          console.log("Something went wrong getting the user info: ", err)
          this.logout();
        }
      });

      this.tokenStorage.getUserAccessCall().subscribe({
        next: (data: any) => {
          this.useraccess = data;
          console.log('this.useraccess', this.useraccess);
          //set foreman to true here if it's a foreman account
          for (var k in this.useraccess){
              if (this.useraccess[k].capability_id == 4){
                this.tokenStorage.saveUserAccess(this.useraccess[k].capability_id);
                this.isForeman = true;
                this.router.navigate(['/chantier']);
              }
          }
        },
        error: (err: any) => {
          console.log("Something went wrong getting the user access: ", err)
          this.logout();
        }
      });

      

    }

    this.getIPAddress();
    this.userAgent = navigator.userAgent;
  }

  onSubmit(): void {
    const { login, password } = this.form;

    this.authService.login(login, password, this.ipAddress, this.userAgent).subscribe({
      next: data => {
        this.tokenStorage.saveToken(data.uuid);
        this.tokenStorage.saveUser(data);
        this.tokenStorage.saveUserAccess(data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        location.reload();
      },
      error: err => {
        this.errorMessage = err.error.message;
        this.isLoginFailed = true;
      }
    });
  }

  getIPAddress() {
    this.http.get("https://api.ipify.org/?format=json").subscribe(
      (response: any) => {
        this.ipAddress = response.ip;
      },
      (error: any) => {
        this.ipAddress = "0.0.0.0";
      }
  )}

  logout(): void {
    this.isLoggedIn = false;
    localStorage.removeItem("token");
    this.router.navigate(['/'])
  }

  isUserLoggedIn(): boolean {
    if (localStorage.getItem("token") != null) {
      return true;
    }
    return false;
  }
}
